import React from 'react';

const badges = props => {
    return (
        <ul className="list-unstyled mb-0 d-flex">
            {props.badges.map(badge => {
                return <li key={badge._id}><img src={badge.image_full} alt="specialdeals"/></li>
                }
             )}
        </ul>
    )
}

export default badges;